<template>
    <nav class="mt-2">
        <MegaMenu v-if="$page.props.auth.user.role === 'admin'" :model="items" orientation="horizontal"
            class="bg-white border-0">
        </MegaMenu>
    </nav>
</template>

<script>
import Icon from '@/Shared/Icon'
import MegaMenu from 'primevue/megamenu';

export default {
    components: {
        Icon,
        MegaMenu
    },
    data() {
        let currentUrl = this.$page.url.substr(1);

        if (currentUrl.startsWith('admin/')) {
            currentUrl = currentUrl.substr(6);
        }

        return {
            currentto: currentUrl,
            items: [
                {
                    label: 'Ship Orders',
                    to: route('admin.orders.ship')
                },
                {
                    label: 'Orders',
                    to: route('admin.orders')
                },
                {
                    label: 'MTD Users',
                    items: [
                        [
                            {
                                items: [
                                    {
                                        label: 'MTD List',
                                        to: route('mtd')
                                    },
                                    {
                                        label: 'Create User',
                                        to: route('mtd.create')
                                    },
                                    {
                                        label: 'Notes',
                                        to: route('admin.notes')
                                    },
                                    {
                                        label: 'Notification Logs',
                                        to: route('admin.notifications')
                                    },
                                    {
                                        label: 'Footer Messages',
                                        to: route('footer_messages.index')
                                    }
                                ]
                            }
                        ]
                    ]
                },
                {
                    label: 'Products',
                    items: [
                        [
                            {
                                items: [
                                    {
                                        label: 'Product List',
                                        to: route('products')
                                    },
                                    {
                                        label: 'Create Product',
                                        to: route('products.create')
                                    },
                                    {
                                        label: 'Import Products',
                                        to: route('import', { 'import_type': 'import_products' })
                                    },
                                    {
                                        label: 'Export Products',
                                        to: route('export.products')
                                    },
                                ]
                            },
                            {
                                label: 'Manage',
                                items: [
                                    {
                                        label: 'Manage Categories',
                                        to: route('categories')
                                    },
                                    {
                                        label: 'Manage Manufacturers',
                                        to: route('manufacturers')
                                    },
                                    {
                                        label: 'Check in Inventory',
                                        to: route('inventory')
                                    },
                                ]
                            },
                            {
                                label: 'Sales',
                                items: [
                                    {
                                        label: 'Manage Sales',
                                        to: route('admin.sales')
                                    },
                                    {
                                        label: 'Create Sale',
                                        to: route('admin.sales.create')
                                    },
                                ]
                            }
                        ]
                    ]
                },
                {
                    label: 'Inventory',
                    items: [
                        [
                            {
                                items: [
                                    {
                                        label: 'Inventory Orders',
                                        to: route('inventory')
                                    },
                                    {
                                        label: 'Create Order',
                                        to: route('inventory.order')
                                    },
                                ]
                            },
                            {
                                label: 'Manage',
                                items: [
                                    {
                                        label: 'Inventory Shipments',
                                        to: route('inventory.shipments')
                                    },
                                    {
                                        label: 'Inventory Product Lookup',
                                        to: route('inventory.fromproducts')
                                    },
                                    {
                                        label: 'Returns to Manufacturer',
                                        to: route('admin.returns.manufacturers')
                                    },
                                ]
                            }
                        ]
                    ]
                },
                {
                    label: 'System',
                    items: [
                        [{
                            items: [
                                {
                                    label: 'Accounting',
                                    to: route('accounting')
                                },
                                {
                                    label: 'Admin Users',
                                    to: route('users')
                                },
                                {
                                    label: 'Create',
                                    to: route('users.create')
                                },
                                {
                                    label: 'Settings',
                                    to: route('admin.settings')
                                },
                                {
                                    label: 'Notification Log',
                                    to: route('admin.notifications')
                                },
                                {
                                    label: 'Notes',
                                    to: route('admin.notes')
                                }
                            ]
                        }]
                    ]
                },
            ]
        };
    },
    methods: {
        isUrl(...urls) {
            let self = this;
            return urls.some(function (url) {
                if (url === '') {
                    return self.currentUrl === '';
                }

                return self.currentUrl.startsWith(url);
            });
        },
    },
}
</script>

<style scoped>
.brand-image {
    max-width: 150px;
}
</style>

<style>
.p-megamenu-submenu-header {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>
